import { SignalWatcher, WithDisposable } from '@blocksuite/affine/global/lit';
import type { LocaleService } from '@blocksuite/affine/shared/services';
import { ShadowlessElement } from '@blocksuite/affine/std';
import { UngroupIcon } from '@blocksuite/icons/lit';
import { html } from 'lit';
import { property } from 'lit/decorators.js';

import type { SelectedContextChip } from './type';
import { translateAIText } from '../../_common/locale';
import { getChipIcon, getChipTooltip } from './utils';

export class ChatPanelSelectedChip extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor chip!: SelectedContextChip;

  @property({ attribute: false })
  accessor locale: LocaleService | null | undefined;

  @property({ attribute: false })
  accessor removeChip!: (chip: SelectedContextChip) => void;

  override render() {
    const { state } = this.chip;
    const isLoading = state === 'processing';
    const tooltip = getChipTooltip(
      this.locale,
      state,
      translateAIText(
        this.locale,
        'chat-panel.chip.selected-content',
        'selected-content'
      ),
      this.chip.tooltip
    );

    const icon = getChipIcon(state, UngroupIcon());

    return html`<chat-panel-chip
      .state=${state}
      .name=${translateAIText(
        this.locale,
        'chat-panel.chip.selected-content',
        'selected-content'
      )}
      .tooltip=${tooltip}
      .icon=${icon}
      .closeable=${!isLoading}
      .onChipDelete=${this.onChipDelete}
    ></chat-panel-chip>`;
  }

  private readonly onChipDelete = () => {
    this.removeChip(this.chip);
  };
}
